import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import { GlobalStyles } from '../../styles/GlobalStyles';

const Layout = () => {
  return (
    <LayoutWrapper>
      <GlobalStyles />
      <Navigation />
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </LayoutWrapper>
  );
};

const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const Main = styled.main`
  flex: 1;
  margin-top: 70px; // Adjust based on your navigation height
  min-height: calc(100vh - 70px);
`;

export default Layout; 